// extracted by mini-css-extract-plugin
export default {"root":"FeedTypeButton_root__u76LO","selected":"FeedTypeButton_selected__vBlq4","radio":"FeedTypeButton_radio__pYUgZ","icon":"FeedTypeButton_icon__qmlfB"};